/**
 * iter163h — Rich card embed for /req and /doc slash commands.
 */
import { FileText, Inbox } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function DMRichCard({ kind, snapshot }) {
  if (!snapshot) return null;
  if (kind === 'request') {
    if (snapshot.missing) {
      return (
        <div className="mt-2 rounded-lg border border-slate-700/60 bg-slate-800/60 px-3 py-2 text-xs text-slate-400" data-testid="dm-card-request-missing">
          Request {snapshot.ref_no} no longer accessible.
        </div>
      );
    }
    return (
      <Link
        to={`/requests/${snapshot.id}`}
        className="mt-2 block rounded-lg border border-slate-700/70 bg-slate-800/70 px-3 py-2 transition-colors hover:bg-slate-700/70"
        data-testid="dm-card-request"
      >
        <div className="flex items-center gap-2 text-xs text-slate-400">
          <Inbox size={12} />
          <span className="rounded bg-slate-700 px-1.5 py-0.5 text-[10px] font-medium text-slate-200">
            {snapshot.type}
          </span>
          <span className="font-mono">{snapshot.ref_no}</span>
        </div>
        <div className="mt-1 text-sm font-medium text-slate-100">
          {snapshot.title || '(no title)'}
        </div>
        <div className="mt-1 text-[11px] uppercase tracking-wide text-slate-500">
          {snapshot.status}
        </div>
      </Link>
    );
  }
  if (kind === 'document') {
    if (snapshot.missing) {
      return (
        <div className="mt-2 rounded-lg border border-slate-700/60 bg-slate-800/60 px-3 py-2 text-xs text-slate-400" data-testid="dm-card-doc-missing">
          Document is no longer accessible.
        </div>
      );
    }
    return (
      <Link
        to={`/requests/${snapshot.request_id}?tab=documents&doc=${snapshot.id}`}
        className="mt-2 block rounded-lg border border-slate-700/70 bg-slate-800/70 px-3 py-2 transition-colors hover:bg-slate-700/70"
        data-testid="dm-card-doc"
      >
        <div className="flex items-center gap-2 text-xs text-slate-400">
          <FileText size={12} />
          <span className="rounded bg-slate-700 px-1.5 py-0.5 text-[10px] font-medium text-slate-200">
            {snapshot.doc_type || 'Document'}
          </span>
        </div>
        <div className="mt-1 text-sm font-medium text-slate-100 truncate">
          {snapshot.filename}
        </div>
      </Link>
    );
  }
  return null;
}
